import { FC } from "react";

import { FeaturedImage } from "@theme/components/FeaturedImage";
import { NavFeaturedImageModule } from "@theme/types";
import { getInternalOrExternalLink } from "@theme/utils/helpers";

import { strapiImageResolver } from "@ms/gatsby-site/src/utils/strapi";

/**
 * Featured Image Module
 *
 * Note this component is shadowed in gatsby-site to add
 * ability to use Strapi Locale Content
 *
 * This version will render the static blog version.
 */
interface FeaturedImageModuleProps extends NavFeaturedImageModule {
  emptyColumnCount?: number;
  closeNavigation: () => void;
}

export const FeaturedImageModule: FC<FeaturedImageModuleProps> = (props) => {
  const image = strapiImageResolver(props.image).childImageSharp.gatsbyImageData;

  const { cta } = props;

  const blogCTA = cta
    ? {
        ...cta,
        link: getInternalOrExternalLink(cta?.link, true),
      }
    : null;

  return (
    <FeaturedImage
      {...props}
      product={null}
      cta={blogCTA}
      image={image}
      emptyColumnCount={props.emptyColumnCount}
      closeNavigation={props.closeNavigation}
    />
  );
};
